import { get, post, put } from "../services/HttpService";
import { axiosIns } from "../services";


export class Ledger {
    constructor(ledgerObject = {}) {
        this.set(ledgerObject);
    };

    static validations = {
        "id": [],
        "uuid": [],
        "created_at": [],
    };

    /**
     * @memberof Ledger
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/ledger/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    /**
     * @memberof Ledger
     * @type API
     * @returns Promise
     */
    static download_report = (queryData = {}, config = {}) => {
        return post('v1/internal/ledger/reports/', queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }
    /**
     * @memberof Ledger
     * @type API
     * @returns Promise
     */
    retreive = (queryData = {}, config = {}) => {
        return get(`v1/internal/ledger/${this.uuid}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Ledger
     * @type API
     * @returns Promise
     */
    static list_connected_bank_statements = (queryData = {}, config = {}) => {
        return get(`v1/internal/ledger/statements/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    /**
     * @memberof Ledger
     * @type API
     * @returns Promise
     */
    static download_connected_bank_statement = (queryData = {}, config = {}) => {
        return post(`v1/internal/ledger/statements/${queryData.id}/download/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    static download_monthly_connected_bank_statement = (queryData = {}, config = {}) => {
        return post(`v1/internal/ledger/statements/download/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }


    /**
     * @memberof Ledger
     * @type Setter Method
     * @takes Ledger Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };
}